import React, { FC, useCallback, useRef } from 'react';
import { Controls } from './controls/controls';
import { CBORLD_MIME_TYPE, downloadFile } from '../../utils/utils';

import { FileProperties } from '../../models/file.models';
import { Editor } from '../editor/editor';
import { Box, Stack } from '@mui/material';
import { FileDropBox, FileDropBoxHandle } from '../file-drop-box/file-drop-box';
import { cssGlobals } from '../../app';
import { FileDescription } from './file-description/file-description';

interface CborPanelProps {
  text: string;
  hex: string;
  binary: Uint8Array;
  fileProperties?: FileProperties;
  onFileLoad: (content: ArrayBuffer, properties: FileProperties) => void;
  onConversionClick: () => void;
}

export const CborPanel: FC<CborPanelProps> = ({
  text, hex, binary, fileProperties, onFileLoad, onConversionClick
}) => {
  const fileDropBox = useRef<FileDropBoxHandle>(null);
  const onDrop = useCallback((files: File[]) => {
    const reader = new FileReader();
    const acceptedFile = files[0];
    reader.readAsArrayBuffer(acceptedFile)

    reader.onabort = () => console.error('file reading was aborted')
    reader.onerror = () => console.error('file reading has failed')
    reader.onload = () => onFileLoad(reader.result as ArrayBuffer, { size: acceptedFile.size, name: acceptedFile.name })
  }, [])

  const add = () => {
    if (fileDropBox.current) {
      fileDropBox.current.importFile();
    }
  }
  const download = () => {
    if (binary) {
      downloadFile(binary, fileProperties?.name, 'application/octet-stream')
    }
  }

  return(
    <Stack>
      <h2>CBOR-LD PANEL</h2>
      {text &&
        <>
          <Stack sx={{height: cssGlobals.boxHeight}}>
            <Box sx={{flexGrow: 3}}>
              <Editor
                mode="text"
                name="text"
                content={text}
                readOnly={true}
              />
            </Box>

            <Box sx={{pt: 3, flexGrow: 1}}>
              <Editor
                mode="text"
                name="hex"
                content={hex}
                readOnly={true}
              />
            </Box>
          </Stack>

          <Controls onAdd={add} onConvert={onConversionClick} onDownload={download}/>
          {fileProperties && <FileDescription
            size={fileProperties.size}
            name={fileProperties.name}
          />}
        </>
      }
      <Box sx={{
        height: cssGlobals.boxHeight,
        display: text ? 'none' : 'block'
      }}>
        <FileDropBox
          ref={fileDropBox}
          text={'Drag \'n\' drop file CBOR-LD file here, or click to select file'}
          accept={{[CBORLD_MIME_TYPE]: ['.cborld']}}
          onDrop={onDrop}
        />
      </Box>
    </Stack>
  )
};
